import * as React from "react";
const Polygon2SVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1440 1024"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    {...props}
  >
    <g filter="url(#a)">
      <path
        fill={props.fill}
        fillOpacity={0.12}
        d="M720 1176 1601.61-90H-161.614L720 1176Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        colorInterpolationFilters="sRGB"
        filterUnits="objectBoundingBox"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_7702_5846"
          stdDeviation={40.6}
        />
      </filter>
    </defs>
  </svg>
);
export default Polygon2SVG;
